type Id = string | number;

/**
 * Template-domain query keys (Server-state rebuild, P4-tail): request templates, block
 * templates, and example documents. Flat roots, preserving today's exact values.
 */
export const templateKeys = {
  requestList: () => ['request-templates'] as const,
  requestListInstantiable: () => ['request-templates', 'instantiable'] as const,
  request: (templateId: Id) => ['request-template', String(templateId)] as const,
  /** Every request template's detail reads, versions and activity included. */
  requestAll: () => ['request-template'] as const,
  requestVersionActivity: (templateId: Id, versionId: Id) =>
    ['request-template', String(templateId), 'version', String(versionId), 'activity'] as const,

  blockList: () => ['block-templates'] as const,
  block: (templateId: Id) => ['block-template', String(templateId)] as const,
  /** Every block template's detail reads, versions and activity included. */
  blockAll: () => ['block-template'] as const,
  blockVersionActivity: (templateId: Id, versionId: Id) =>
    ['block-template', String(templateId), 'version', String(versionId), 'activity'] as const,

  exampleDocuments: () => ['example-documents'] as const,
  requestExampleDocument: (auditId: string, requestId: string, exampleDocumentId: string) =>
    ['example-documents', 'request', auditId, requestId, exampleDocumentId] as const,
} as const;
